import { render, staticRenderFns } from "./TabulationItem.vue?vue&type=template&id=4f2d898b&"
import script from "./TabulationItem.vue?vue&type=script&lang=js&"
export * from "./TabulationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports